import CircularProgress from "@mui/material/CircularProgress";
import { UseQueryResult, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import AlertDefault, { AlertVariant } from "../Alerts/AlertDefault";
import ButtonDefault from "../Button/ButtonDefault";

type RenderQueryResultProps = {
  query: UseQueryResult;
  children: React.ReactNode;
  queryKey?: string;
} & React.ComponentProps<"div">;

export default function RenderQueryResult({
  query,
  children,
  queryKey,
  ...restProps
}: RenderQueryResultProps): JSX.Element {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const id = "RenderQuery";
  const renderError = (error: Error) => {
    return (
      <div id="QueryErrorAlert" {...restProps}>
        <AlertDefault variant={AlertVariant.Error}>
          {error.message ?? "Ingen data funnet"}
        </AlertDefault>
        <ButtonDefault
          id={`${id}RetryButton`}
          label={t("actions.retry")}
          onClick={async () => query.refetch()}
        />
      </div>
    );
  };

  const renderSpinner = () => {
    return (
      <div className="flex flex-col items-center justify-center">
        <div className="flex flex-row items-center justify-center">
          <CircularProgress thickness={7} size={80} />
        </div>
      </div>
    );
  };

  return (
    <div id={id} {...restProps}>
      {query.isSuccess ? (
        children
      ) : queryClient.getQueryData([queryKey]) != undefined ? (
        <>
          {children}
          <ButtonDefault
            id={`${id}RetryButton`}
            label={t("actions.retry")}
            onClick={async () => query.refetch()}
          />
        </>
      ) : query.isError && !query.isRefetching ? (
        renderError(query.error)
      ) : (
        renderSpinner()
      )}
    </div>
  );
}
